import React from 'react'
import PropTypes from 'prop-types'

class AwaitShouldMount extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            hasMounted: false,
        }
    }

    componentDidUpdate() {
        const { shouldMount } = this.props
        const { hasMounted } = this.state

        if (shouldMount && !hasMounted) {
            this.setState({ hasMounted: true })
        }
    }

    render() {
        const { shouldMount, children, ...rest } = this.props
        const { hasMounted } = this.state
        if (!shouldMount && !hasMounted) {
            return null
        }
        const childrenWithProps = React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
                return React.cloneElement(child, {
                    ...rest,
                    shouldMount,
                })
            }
            return child
        })
        return (
            <>
                {childrenWithProps}
            </>
        )
    }
}

AwaitShouldMount.defaultProps = {
    shouldMount: true,
}

AwaitShouldMount.propTypes = {
    shouldMount: PropTypes.bool,
    children: PropTypes.node.isRequired,
}

const AwaitShouldMountHOC = (InjectedComponent) => {
    const WithInjectionComponent = (props) => (
        <AwaitShouldMount {...props}>
            <InjectedComponent />
        </AwaitShouldMount>
    )
    return WithInjectionComponent
}

export default AwaitShouldMountHOC
